export const PLUGIN_INFO = {
    sidebarId   : 'sgf-sidebar',
    sidebarIcon : 'editor-textcolor',
    pluginName  : 'Simple Google Fonts',
};

export const HEADINGS = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
];

export const FONT_WEIGHT = [
    '100', '100i', 
    '200', '200i', 
    '300', '300i',
    '400', '400i',
    '500', '500i',
    '600', '600i',
    '700', '700i',
    '800', '800i',
    '900', '900i'
];

export const TEXT_TRANSFORM = [
    'none', 'capitalize', 'uppercase', 'lowercase'
];

export const HEADINGS_TABS = [
    {
        name: 'h1',
        title: 'h1',
        className: 'tab-one',
    },
    {
        name: 'h2',
        title: 'h2',
        className: 'tab-two',
    },
    {
        name: 'h3',
        title: 'h3',
        className: 'tab-three',
    },
    {
        name: 'h4',
        title: 'h4',
        className: 'tab-four',
    },
    {
        name: 'h5',
        title: 'h5',
        className: 'tab-five',
    },
    {
        name: 'h6',
        title: 'h6',
        className: 'tab-six',
    },
]